import { ValidateJSModel } from 'forms/shared/types';
import { LocationModel } from '../types';
import { getUSInclusionsByForm } from 'helpers/form';

interface LocationStateModel {
  state: LocationModel['state']
}

const locationStateModelValidator: ValidateJSModel<LocationStateModel> = {
  state: (value, attributes, attributeName, options) => {
    return {
      presence: true,
      inclusion: getUSInclusionsByForm(options?.formType),
    };
  },
};

export default locationStateModelValidator;
